const gridItems = document.querySelector('.js-grid-items');
let keys = {}

if (gridItems) {
  refreshItems(gridItems);
  placeItems(gridItems)

  document.addEventListener('facetwp-loaded', () => {
    refreshItems(gridItems);
    placeItems(gridItems)
  })

  window.addEventListener('resize', () => {
    placeItems(gridItems)
  })
}

function refreshItems(gridItems) {
  keys = {}
  const items = gridItems.querySelectorAll('.posts__item');
  let currentKey = ''
  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    if (item.classList.contains('js-grid-items-key')) {
      currentKey = item.textContent
      continue;
    }

    if (typeof keys[currentKey] === 'undefined') {
      keys[currentKey] = [item]
    } else {
      keys[currentKey].push(item)
    }
  }
}

function placeItems(gridItems) {
  const type = gridItems.dataset.gridItemsType;
  for (const key in keys) {
    if (Object.hasOwnProperty.call(keys, key)) {
      const items = keys[key];

      for (let index = 0; index < items.length; index++) {
        const item = items[index];
        item.style.gridColumnStart = ''

        if (type === 'artists') {
          if (index % 4 === 0 && window.innerWidth >= 1440) {
            item.style.gridColumnStart = '4'
          } else if (index % 3 === 0 && window.innerWidth >= 1024 &&  window.innerWidth < 1440) {
            item.style.gridColumnStart = '3'
          }
        }
        // else if (type === 'cycles') {
        //   if (index % 2 === 0 && window.innerWidth >= 1440) {
        //     item.style.gridColumnStart = '4'
        //   }
        //   else if (index % 3 === 0 && window.innerWidth >= 1024 &&  window.innerWidth < 1440) {
        //     item.style.gridColumnStart = '3'
        //   }
        // }
      }
    }
  }
}
